import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "@tanstack/react-router";
import { t } from "i18next";
import { Flex } from "@/components/layout/flex/flex";
import error400Svg from "@/assets/error-400.svg";

export function NotFoundErrorPage() {
	const navigate = useNavigate();

	return (
		<Box
			height="100%"
			display="flex"
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
		>
			<img
				src={error400Svg}
				alt="404 Error"
				style={{ maxWidth: "400px", width: "100%" }}
			/>
			<Typography mt={4} variant="h6">
				{t("Oops! Page not found")}
			</Typography>
			<Typography mt={1} variant="body2" color="text.secondary">
				{t("We couldn't find the page you're looking for")}
			</Typography>
			<Typography variant="body2" color="text.secondary">
				{t("It might have been moved or doesn't exist anymore")}
			</Typography>
			<Flex mt={2} gap={2}>
				{/* <Button>
					{t("Visit our help center")}
				</Button> */}
				<Button
					variant="contained"
					color="primary"
					onClick={() => void navigate({ to: "/" })}
				>
					{t("Back to application")}
				</Button>
			</Flex>
		</Box>
	);
}
